module.exports = __webpack_public_path__ + "static/img/重点项目之一.f3ba286d.png";